import { ErrorResponse,  } from '@gtpl/shared-models/common-models';
import { AllInterviewResponseModel, DtoOfRecruitmentDashboard, InterviewReportDto, InterviewReportResponse, InterviewResponseModel,  ResponseObjectForRecruitment } from '@gtpl/shared-models/hrms';

import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';

import { Entity, getManager, Repository } from 'typeorm';

import appSettings from 'apps/services/config';

import { Interview } from './interview.entity';

import { interviewAdapter } from './dto/interview.adapter';
import { interviewDTO } from './dto/interview.dto';
import { interviewRequest } from './dto/interview.request';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { IdRequest } from './dto/idRequest'
import { unitreq } from './dto/unitreq';

@Injectable()
export class InterviewService {


    constructor(
        @InjectRepository(Interview)
        private repository: Repository<Interview>,
        private adapter: interviewAdapter,

    ) { }

    async getinterview(interviewId: number): Promise<Interview> {
        const response = await this.repository.findOne({
            where: { interviewId: interviewId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createinterview(data: interviewDTO, isUpdate: boolean): Promise<InterviewResponseModel> {
        try {
            console.log(data);
            console.log(isUpdate);
            if (!isUpdate) {
                const entity = await this.getinterview(data.interviewId);
                if (entity) {
                    throw new ErrorResponse(11104, 'interview already exits');
                }
            } else {
                const interviewEntity = await this.getinterview(data.interviewId);
                if (interviewEntity) {
                    if (interviewEntity.interviewId != data.interviewId) {
                        throw new ErrorResponse(11104, 'interview already exits');
                    }
                }
            }
            const convertedDto: Interview = await this.adapter.convertDtoToEntity(data);
            const savedinterview: Interview = await this.repository.save(convertedDto);
            const convertedinterview: interviewDTO = await this.adapter.convertEntityToDto(savedinterview);

            if (convertedinterview) {
                const response = new InterviewResponseModel(true, isUpdate ? 11100 : 11101, isUpdate ? 'interview updated successfully' : 'interview created successfully');
                return response;
            } else {
                throw new ErrorResponse(11106, 'interview is saved but error while converting it into DTO');
            }
        } catch (error) {
            return error;
        }
    }

    // async getAllinterview(): Promise<AllInterviewResponseModel>{
    //     try{
    //         const interview : interviewDTO[] = [];
    //         const entities : Interview[] = await this.repository.find({
    //             order: {interviewId: 'ASC'},
    //         });
    //         if(entities.length>0){
    //             entities.forEach(Entity => {
    //                 const convertedinterview: interviewDTO = this.adapter.convertEntityToDto(Entity);
    //                 interview.push(convertedinterview); 
    //             });
    //             const response = new AllInterviewResponseModel(true, 11208, 'interview retrieved successfully', interview);
    //             return response;
    //         }else{
    //             throw new ErrorResponse(99998, 'No Records Found');
    //         }
    //     }catch(error){
    //         return error;
    //     }
    // }

    async getAllinterview(): Promise<AllInterviewResponseModel> {
        try {
            const manager = getManager();
            const query = `SELECT  i.interview_id as interviewId,i.interview_date as interviewDate , i.plant as plant, i.job_description as jobDescription, i.candidate_name as candidateName, i.remarks as remarks,i.is_active as isActive, i.created_at as createdAt,i.created_user as createdUser,i.updated_at as updatedAt,i.updated_user as updatedUser,i.version_flag as versionFlag,i.interviewer_mobile_no as interviewerMobileNo,i.status as status,i.refereed_by as refereedBy,ed.employee_name as interviewer , i.interview_type as interviewType,i.notification_id AS notificationId,CONCAT(ed.employee_name," ",ed.emp_last_name) AS empfullname  FROM ` + appSettings.hrms_db + `.interview i
            LEFT JOIN ` + appSettings.masters_db + `.employee_details ed ON ed.employee_id = i.interviewer order By createdAt desc`
            const data = await manager.query(query)
            if (data.length > 0) {
                const response = new AllInterviewResponseModel(true, 11208, "Interview retrieved successfully", data);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Record Found');
            }
        } catch (err) {
            return err
        }
    }


    async getinterviewById(id: number): Promise<Interview> {
        const response = await this.repository.findOne({
            where: { interviewId: id },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateinterview(req: interviewRequest): Promise<InterviewResponseModel> {
        try {
            const interviewExists = await this.getinterviewById(req.interviewId);
            if (interviewExists) {
                if (req.versionFlag != interviewExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current interview information. Refresh and try again');
                } else {
                    const interviewtatus = await this.repository.update(
                        { interviewId: req.interviewId },
                        { isActive: req.isActive, updatedUser: req.updatedUser },
                    );
                    if (interviewExists.isActive) {
                        if (interviewtatus.affected) {
                            const response: InterviewResponseModel = new InterviewResponseModel(true, 10115, 'interview is de-activated successfully');
                            return response;
                        } else {
                            throw new ErrorResponse(10111, 'interview is already de-activated');
                        }
                    } else {
                        if (interviewtatus.affected) {
                            const response: InterviewResponseModel = new InterviewResponseModel(true, 10114, 'interview is activated successfully');
                            return response;
                        } else {
                            throw new ErrorResponse(10112, 'interview is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (error) {
            return error;
        }
    }

    async getAllActiveinterview(): Promise<AllInterviewResponseModel> {
        try {
            const interview: interviewDTO[] = [];
            const entities: Interview[] = await this.repository.find({
                order: { interviewId: 'ASC' }, where: { isActive: true },
            });
            if (entities.length > 0) {
                entities.forEach(Entity => {
                    const interview: interviewDTO = this.adapter.convertEntityToDto(Entity);
                    interview.push(interview);
                });
                const response = new AllInterviewResponseModel(true, 11208, 'interview retrieved successfully');
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (error) {
            return error;
        }
    }


    async getInterviewReportingData(): Promise<InterviewReportResponse> {
        const manager = getManager()
        const query =
            ' SELECT a.job_description AS jobDescription,COUNT( a.job_description) AS totalProfileAssigned ,SUM(IF(b.STATUS="Rejected",1,0)) AS rejected,SUM(IF(b.STATUS="Open",1,IF(b.STATUS="Pending",1,0))) AS toBeInterviewed,SUM(IF(b.STATUS="Selected",1,0)) AS totalSelect FROM ' + appSettings.hrms_db + '.notifications  a LEFT JOIN ' + appSettings.hrms_db + '.interview  b ON a.notification_id = b.notification_id   GROUP BY a.notification_id'

        const data = await manager.query(query);
        console.log(data);
        if (data.length > 0) {
            const respDtos = data.map(item => new InterviewReportDto(item.jobDescription, item.totalProfileAssigned, item.toBeInterviewed, item.rejected, item.totalSelect));
            const response = new InterviewReportResponse(true, 1111, 'Data retrived successfully', respDtos);
            return response;
        } else {
            return new InterviewReportResponse(false, 10, 'Data not found');
        }

    }


    async getRecruitmentData(): Promise<ResponseObjectForRecruitment> {
        const manager = getManager()
        const query =

          ' SELECT a.plant AS Plant, a.job_description AS jobDescription,COUNT( a.job_description) AS totalProfileAssigned ,SUM(IF(b.STATUS="Rejected",1,0)) AS Rejected , SUM(IF(b.STATUS="Open",1,IF(b.STATUS="Pending",1,0))) AS toBeInterviewed,SUM(IF(b.STATUS="Selected",1,0)) AS Selected ,a.status AS Status FROM ' + appSettings.hrms_db + '. notifications  a LEFT JOIN ' + appSettings.hrms_db + '. interview  b ON a.notification_id = b.notification_id  GROUP BY a.notification_id';

        const data = await manager.query(query);
        console.log(data);
        if (data.length > 0) {
             const respDtos= data.map(item=>new DtoOfRecruitmentDashboard(item.Plant,item.jobDescription,item.totalProfileAssigned,item.Rejected,item.toBeInterviewed,item.Selected,item.Status,));
            const response = new ResponseObjectForRecruitment(true, 1112, 'Data retrived successfully', respDtos);
            return response;

        } else {
            return new ResponseObjectForRecruitment(false, 11, 'Data not found');
        }

    }

    async getIDJob():Promise<CommonResponse>{
        try{
          const manager=getManager();
          const query = 'SELECT notification_id AS notificationId,job_description AS jobDescription FROM notifications WHERE STATUS not in("Closed","Cancelled") '
          const result = await manager.query(query)
          if(result){
            return new CommonResponse(true, 1111, "Data retreived sucessfully",result)          
          }else{
            return new CommonResponse(false, 1111, "Error occure")
          
          }
            }
            catch(err){
            return err;
            }
          
        }

        async getRecruitmentDataForUnit(req:unitreq): Promise<ResponseObjectForRecruitment> {
            const manager = getManager()
            const query = ' SELECT a.plant AS Plant, a.job_description AS jobDescription,COUNT( a.job_description) AS totalProfileAssigned ,SUM(IF(b.STATUS="Rejected",1,0)) AS Rejected , SUM(IF(b.STATUS="Open",1,IF(b.STATUS="Pending",1,0))) AS toBeInterviewed,SUM(IF(b.STATUS="Selected",1,0)) AS Selected ,a.status AS Status FROM ' + appSettings.hrms_db + '. notifications  a LEFT JOIN ' + appSettings.hrms_db + '. interview  b ON a.notification_id = b.notification_id WHERE plant_id='+req.plant_id+' GROUP BY a.notification_id';
            // console.log(query)
              const result = await manager.query(query)
              if(result){
                return new CommonResponse(true, 1111, "Data retreived sucessfully",result)          
              }else{
                return new CommonResponse(false, 1111, "Error occure")
              
              }
                }
                catch(err){
                return err;
                }
    
        }






